import {
  AlignmentType,
  convertMillimetersToTwip,
  Footer,
  NumberFormat,
  PageNumber,
  PageOrientation,
  Paragraph,
  TextRun,
} from 'docx'

const MARGINS = {
  top: convertMillimetersToTwip(20),
  right: convertMillimetersToTwip(20),
  bottom: convertMillimetersToTwip(15),
  left: convertMillimetersToTwip(20),
}

function defaultFooter() {
  return {
    default: new Footer({
      children: [
        new Paragraph({
          alignment: AlignmentType.RIGHT,
          children: [
            new TextRun({
              children: [PageNumber.CURRENT],
            }),
          ],
        }),
      ],
    }),
  }
}

const A4_WIDTH_MM = 210
const A4_HEIGHT_MM = 297

/** Секция книжной ориентации (основной текст представления). */
export function portraitSectionProps(children) {
  return {
    footers: defaultFooter(),
    properties: {
      page: {
        size: {
          orientation: PageOrientation.PORTRAIT,
          width: convertMillimetersToTwip(A4_WIDTH_MM),
          height: convertMillimetersToTwip(A4_HEIGHT_MM),
        },
        margin: MARGINS,
        pageNumbers: { formatType: NumberFormat.DECIMAL },
      },
    },
    children,
  }
}

/** Альбомная секция (раздел 3 — расчёт затрат). */
export function landscapeSectionProps(children) {
  return {
    footers: defaultFooter(),
    properties: {
      page: {
        size: {
          orientation: PageOrientation.LANDSCAPE,
          width: convertMillimetersToTwip(A4_WIDTH_MM),
          height: convertMillimetersToTwip(A4_HEIGHT_MM),
        },
        margin: MARGINS,
        pageNumbers: { formatType: NumberFormat.DECIMAL },
      },
    },
    children,
  }
}
